import { UseBoundStore } from 'zustand';

import { allStores as defaultAllStores } from './constants/allStores';
import { hasPersist as defaultHasPersist } from './hasPersist';

/**
 * Returns a list of all localStorage keys currently registered by the persist middleware,
 * combined with any additional keys that should be preserved.
 *
 * __anon_id: A persist key used by the `analyticStore` to store an anonymous user ID. see: https://github.com/DavidWells/analytics/issues/345
 */
export const getAllowedStorageKeys = (
  allStores: UseBoundStore<any>[] = defaultAllStores,
  hasPersist: (store: UseBoundStore<any>) => boolean = defaultHasPersist,
): string[] => {
  const keys = ['__anon_id'];

  for (const store of allStores) {
    if (hasPersist(store)) {
      const { name } = store.persist.getOptions();

      if (name && !keys.includes(name)) {
        keys.push(name);
      }
    }
  }

  return keys;
};
